<template>
  <div :class="singleFundcode == null?'common-box border-t0':'common-box'">
    <el-row class="row-one">
      <span class="row-one-title">基金记录</span>
      <Reback class="row-one-fr" @click.native="returnClick" v-show="singleFundcode == null"></Reback>
      <span class="row-one-fr" @click="detailsClick" v-show="singleFundcode == null">查看资产详情</span>
    </el-row>
    <!-- 主页 -->
    <el-form class="form-single-inline margin-t20" :inline="true" :model="formInlieOne">
      <el-form-item label="查询基金：" v-if="singleFundcode == null">
        <el-input v-model="formInlieOne.fundname" placeholder="请输入基金代码查询"></el-input>
      </el-form-item>
      <!-- 时间 -->
      <el-form-item label="起止日期：">
        <el-radio-group v-model="formInlieOne.datetype" class="radio-single-btn1" @change="dateChange">
          <el-radio-button v-for="(item,i) in setTimeData" :label="item.time" :key="i+'dt'">{{item.name}}</el-radio-button>
        </el-radio-group>
        <el-date-picker v-model="formInlieOne.datevalue1" type="date" placeholder="选择日期" @change="dateOneChange">
        </el-date-picker>
        至
        <el-date-picker v-model="formInlieOne.datevalue2" type="date" placeholder="选择日期" @change="dateTwoChange">
        </el-date-picker>
        <el-button type="search" class="margin-l10" @click="searchClick">查询 <i class="el-icon-search"></i></el-button>
      </el-form-item>
      <br>
      <!-- 状态 -->
      <el-form-item label="交易状态：">
        <el-radio-group v-model="formInlieOne.status" class="radio-single-btn1" @change="stateChange">
          <el-radio-button v-for="(item,i) in tradeStateData" :label="item.value" :key="i+'lx'">{{item.name}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <br>
      <!-- 类型 -->
      <el-form-item label="交易类型：">
        <el-radio-group v-model="formInlieOne.type" class="radio-single-btn1" @change="typeChange">
          <el-radio-button v-for="(item,i) in tradeTypeData" :label="item.value" :key="i+'lx'">{{item.name}}</el-radio-button>
        </el-radio-group>
        <span class="form-single-inline-tip">注：包含设置分红方式/基金份额增强、强减、强赎/定期申购协议/定期申购撤销</span>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table v-show="allShow" :data="tradeTableData" style="width: 100%;" class="table-single margin-t10" v-loading="loading" element-loading-text="加载中...">
      <el-table-column prop="time" label="申请时间" width="160"></el-table-column>
      <el-table-column prop="fundname" label="基金名称" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundname" placement="right">
            <a :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundcode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundname}}</a>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="交易类型" width="105"></el-table-column>
      <el-table-column prop="applicationamount" label="申请数额" width="110">
        <template slot-scope="scope">
          <!-- 买入 -->
          <span v-show="scope.row.businesscode != '24' && scope.row.businesscode != '36'">{{scope.row.applicationamount == '--'? scope.row.applicationamount : scope.row.applicationamount + '元'}}</span>
          <span v-show="scope.row.businesscode == '24' || scope.row.businesscode == '36'">{{scope.row.applicationvol+'份'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nav" label="确认净值" width="90">
        <template slot-scope="scope">{{scope.row.nav == '--'? '--': parseFloat(scope.row.nav).toFixed(4)}}</template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="confirmedvol" label="确认数额" width="90">
        <template slot-scope="scope">{{scope.row.confirmedvol == '0.00'? '--':scope.row.confirmedvol+'份'}}</template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="charge" label="手续费" width="70"></el-table-column>
      <el-table-column prop="account" label="关联账户" width="120"></el-table-column>
      <el-table-column prop="newstatus" label="交易状态"> </el-table-column>
      <el-table-column prop="operation" label="操作">
        <template slot-scope="scope">
          <span class="table-single-btn-normal" @click="tradeDetails(scope.row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 买入表格 -->
    <el-table v-show="buyShow" :data="tradeTableData" style="width: 100%;" class="table-single margin-t10" v-loading="loading" element-loading-text="加载中...">
      <el-table-column prop="time" label="申请时间" width="160"></el-table-column>
      <el-table-column prop="fundname" label="基金名称" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundname" placement="right">
            <a href="javascript:;" class="table-single-a">{{scope.row.fundname}}</a>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="applicationamount" label="购买金额">
        <template slot-scope="scope">{{scope.row.applicationamount + '元'}}</template>
      </el-table-column>
      <el-table-column prop="nav" label="确认净值">
        <template slot-scope="scope">{{scope.row.nav == '--'? '--': parseFloat(scope.row.nav).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="confirmedvol" label="确认份额">
        <template slot-scope="scope">{{scope.row.confirmedvol + '份'}}</template>
      </el-table-column>
      <el-table-column prop="charge" label="手续费"></el-table-column>
      <el-table-column prop="account" label="关联账户" width="120"></el-table-column>
      <el-table-column prop="newstatus" label="交易状态"> </el-table-column>
      <el-table-column prop="operation" label="操作">
        <template slot-scope="scope">
          <span class="table-single-btn-normal" @click="tradeDetails(scope.row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 卖出 -->
    <el-table v-show="sellShow" :data="tradeTableData" style="width: 100%;" class="table-single margin-t10" v-loading="loading" element-loading-text="加载中...">
      <el-table-column prop="time" label="申请时间" width="160"></el-table-column>
      <el-table-column prop="fundname" label="基金名称" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundname" placement="right">
            <a href="javascript:;" class="table-single-a">{{scope.row.fundname}}</a>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="applicationvol" label="赎回份额">
        <template slot-scope="scope">{{scope.row.applicationvol + '份'}}</template>
      </el-table-column>
      <el-table-column prop="nav" label="确认净值">
        <template slot-scope="scope">{{scope.row.nav == '--'? '--': parseFloat(scope.row.nav).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="confirmedamount" label="确认金额">
        <template slot-scope="scope">{{scope.row.confirmedamount + '元'}}</template>
      </el-table-column>
      <el-table-column prop="charge" label="手续费"></el-table-column>
      <el-table-column prop="account" label="关联账户" width="120"></el-table-column>
      <el-table-column prop="newstatus" label="交易状态"> </el-table-column>
      <el-table-column prop="operation" label="操作">
        <template slot-scope="scope">
          <span class="table-single-btn-normal" @click="tradeDetails(scope.row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <el-pagination class="pagination-single" @current-change="handleCurrentChangeOne" :current-page.sync="publicRecord.Page" :page-size="publicRecord.PageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
    </el-pagination>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  name: "publicRecord",
  props: ['singleFundcode', 'singleFundMessage'],
  data () {
    return {
      tradeTableData: [],
      publicRecord: {
        Page: 1,
        PageNum: 20
      },
      total: 0,
      // 时间多选
      setTimeData: [
        {
          name: '全部',
          time: ''
        },
        {
          name: '近一周',
          time: this.$commonJs.getBeforeDate(7, 'd7', '/')
        },
        {
          name: '近一月',
          time: this.$commonJs.getBeforeDate(0, 1, '/')
        },
        {
          name: '近三月',
          time: this.$commonJs.getBeforeDate(0, 3, '/')
        },
        {
          name: '近半年',
          time: this.$commonJs.getBeforeDate(0, 6, '/')
        },
        {
          name: '近一年',
          time: this.$commonJs.getBeforeDate(0, 12, '/')
        }
      ],
      tradeStateData: [
        {
          name: '不限',
          value: '',
        },
        {
          name: '确认中',
          value: '01',
        },
        {
          name: '成功',
          value: '02',
        },
        {
          name: '失败',
          value: '03',
        },
        {
          name: '已撤单',
          value: '04',
        },
      ],
      tradeTypeData: [
        {
          name: '不限',
          value: '',
        },
        {
          name: '买入',
          value: '01',
        },
        {
          name: '卖出',
          value: '02',
        },
        {
          name: '定投',
          value: '03',
        },
        {
          name: '分红',
          value: '04',
        },
        {
          name: '转换',
          value: '05',
        },
        {
          name: '其他',
          value: '06',
        },
      ],
      // 记录详情
      fundName: '',
      //筛选条件
      formInlieOne: {
        fundname:'',
        datetype: this.$commonJs.getBeforeDate(7, 'd7', '/'),
        type: '',
        status: '',
        datevalue1: this.$commonJs.getBeforeDate(7, 'd7', '/'),
        datevalue2: this.$commonJs.getBeforeDate(0, 'd7', '/'),
      },
      loading: true,
      allShow: true,
      buyShow: false,
      sellShow: false,
    }
  },
  created () {

  },
  mounted () {
    this.getPublicRecord()
  },
  methods: {
    returnClick () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    detailsClick () {
      this.$router.push({
        name: 'publicAssetsMessage',
        params: {
          value: 'publicRecord'
        },
      })
    },
    handleCurrentChangeOne (newPage) {
      this.loading = true
      this.publicRecord.Page = newPage
      this.getPublicRecord()
    },
    // 选项时间
    dateChange (val) {
      this.formInlieOne.datevalue1 = val
      this.formInlieOne.datevalue2 = this.$commonJs.getBeforeDate(0, 'd7', '/')
    },
    // 开始日期
    dateOneChange (val) {
      this.formInlieOne.datetype = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '')
      this.formInlieOne.datevalue1 = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '/')
    },
    // 结束日期
    dateTwoChange (val) {
      // this.formInlieOne.datetype = '1'
      // this.formInlieOne.datevalue1 = this.$commonJs.getBeforeDate(0, 36, '')
      this.formInlieOne.datevalue2 = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '/')
    },
    // 查询
    searchClick () {
      this.loading = true
      if (this.formInlieOne.type == '01') {//买入
        this.buyShow = true
        this.allShow = false
        this.sellShow = false
      } else if (this.formInlieOne.type == '02') {//卖出
        this.buyShow = false
        this.allShow = false
        this.sellShow = true
      } else {
        this.buyShow = false
        this.allShow = true
        this.sellShow = false
      }
      this.publicRecord.Page = 1
      this.getPublicRecord()
    },
    // 状态改变
    stateChange (val) {
      this.$emit("slected", val)
      // this.loading = true
      // this.formInlieOne.state = val
      // this.getPublicRecord()
    },
    // 类型改变
    typeChange (val) {
      // this.loading = true
      // this.formInlieOne.type = val
      // this.getPublicRecord()
    },
    tradeDetails (rows) {
      this.$http.post(this.$apiPath.qerySingelDetailTrades, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1'),
        appsheetserialno: rows.appsheetserialno,
        businesscode: rows.businesscode,
        taserialno: rows.taserialno,
        fundcode: rows.fundcode,
      }).then(res => {
        if(res.data.code == 200) {
          let result = res.data.data
          if (result.publicRecord) {
            // console.log(result.publicRecord[0]);
            this.$router.push({
              name: 'publicRecordDetail',
              params: {
                message: rows,
                detail: result.publicRecord[0],
                singleFlag: this.singleFundcode,
                singleMessage: this.singleFundMessage
              }
            })
          }
        }
      }).catch(err => { })

    },
    // 公募记录
    getPublicRecord () {
      // console.log(this.singleFundcode);
      let begin = ''
      if (this.formInlieOne.datetype == '') {
        begin = this.$commonJs.getBeforeDate(0, 36, '')
      } else {
        begin = this.formInlieOne.datevalue1.replace('/', '').replace('/', '')
      }
      this.$http.post(this.$apiPath.qeryPublicTradesnew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        paycenterid: "",
        begindate: begin,
        enddate: this.formInlieOne.datevalue2.replace('/', '').replace('/', ''),
        businesscode: "",
        fundcode: this.singleFundcode == null ? this.formInlieOne.fundname : this.singleFundcode,
        transcode: this.formInlieOne.type,//交易类型
        status: this.formInlieOne.status,//交易状态
        transstatus: "",
        requestid: this.publicRecord.Page,
        appnew: 1
      }).then(res => {
        // console.log(res);
        this.loading = false
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result.publicRecord.length > 0) {
          result.publicRecord.forEach(item => {
            // 申请日期
            item.time = this.$commonJs.getDateStrHg(item.operdate) + ' ' + item.opertime
            // 交易类型
            if (item.businesscode == "22" || item.businesscode == "20") {
              item.type = "买入"
            } else if (item.businesscode == "24") {
              item.type = "卖出"
            } else if (item.businesscode == "39") {
              item.type = "定期定额申购"
            } else if (item.businesscode == "59") {
              item.type = "定期定额开通"
            } else if (item.businesscode == "60") {
              item.type = " 定投协议撤销"
            } else if (item.businesscode == "43") {
              item.type = "分红"
            } else if (item.businesscode == "36" || item.businesscode == "37" || item.businesscode == "38") {
              item.type = "基金转换"
            } else if (item.businesscode == "26") {
              item.type = "转托管"
            } else if (item.businesscode == "27") {
              item.type = "转托管转入"
            } else if (item.businesscode == "28") {
              item.type = "转托管转出"
            } else if (item.businesscode == "29") {
              item.type = "设置分红方式 "
            } else if (item.businesscode == "42") {
              item.type = "强制赎回"
            } else if (item.businesscode == "44") {
              item.type = "强行调增"
            } else if (item.businesscode == "45") {
              item.type = "强行调减"
            } else if (item.businesscode == "61") {
              item.type = "定期申购修改"
            }
            // 交易状态
            if (item.transstatus == '00') {
              item.newstatus = "已撤单";
            } else if (item.transstatus == '01') {
              item.newstatus = "确认成功";
            } else if (item.transstatus == '02') {
              item.newstatus = "确认失败";
            } else if (item.transstatus == '03') {
              item.newstatus = "确认中";
            } else if (item.transstatus == '04') {
              item.newstatus = "受理失败";
            } else if (item.transstatus == '05') {
              item.newstatus = item.paytype == '1'? "受理失败" : "待支付"
            } else if (item.transstatus == '06') {
              item.newstatus = "交易关闭";
            } else if (item.transstatus == '07') {//异常
              item.newstatus = "待勾兑";
            } else if (item.transstatus == '08') {
              item.newstatus = "待勾兑";
            } else {
              item.newstatus = "--";
            }
            // 关联账户
            item.account = this.getPayModeByPayMethod(item.connectaccount, item.channelid, item.depositacct)
            // 手续费
            item.charge ? item.charge = item.charge + '元' : item.charge = '--'
          });
          this.tradeTableData = result.publicRecord
          this.total = result.totalNum
        } else {
          this.tradeTableData = []
          this.total = 0
        }

      }).catch(err => { })
    },
    // 账户
    getPayModeByPayMethod (paymethod, channelid, depositcard) {
      var paymode = "银行卡";
      if (paymethod == "1") {
        paymode = "恒宝宝";
      } else if (paymethod == "2") {
        paymode = "优惠券";
      } else if (paymethod == "3") {
        var bank = this.$commonJs.getBankInfo(channelid);
        var card = depositcard ? depositcard.substr(depositcard.length - 4, 4) : '--';
        paymode = bank + '(' + card + ')' + '+优惠券';
      } else if (paymethod == "4") {
        var bank = this.$commonJs.getBankInfo(channelid);
        var card = depositcard ? depositcard.substr(depositcard.length - 4, 4) : '--';
        paymode = bank + '(' + card + ')';
      } else if (paymethod == "5") {
        paymode = "恒宝宝+优惠券";
      }
      return paymode;
    },

  }
}
</script>

<style lang="less" scoped>
</style>